var React = require('react');

function EvzerLogoNavSpacerInline (props) {
    return React.createElement("svg",props,React.createElement("rect",{"id":"spacer","x":"-2.6","y":"52.3","width":"892","height":"28.4"}));
}

EvzerLogoNavSpacerInline.defaultProps = {"version":"1.1","id":"Calque_1","x":"0px","y":"0px","viewBox":"0 0 892 133.2","style":{"enableBackground":"new 0 0 892 133.2"},"xmlSpace":"preserve","preserveAspectRatio":"none"};

module.exports = EvzerLogoNavSpacerInline;

EvzerLogoNavSpacerInline.default = EvzerLogoNavSpacerInline;
